import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconHomeComponent } from "./med-icon-home.component";

@NgModule({
  declarations: [
    MedIconHomeComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconHomeComponent,
  ],
})
export class MedIconHomeModule { }
